import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import language from "../../../../language";
import CitiesData from "./cities.json";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Form from "react-bootstrap/Form";
import Grid from "@mui/material/Grid";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector, useDispatch } from "react-redux";
import {
  searchBuses,
  requestInfo,
  UpdaterequestInfo,
  updateDepartureDate,
  updateDates,
} from "../../../../actions/buses";
//icons
import { HiOutlineLocationMarker } from "react-icons/hi";
import Passengers from "../../Dashboard/Passengers";
import CalendarComponent from "../../Dashboard/CalendarComponent";
import "./SearchBus.scss";
import Swal from "sweetalert2";

export default function SearchForm({
  setIsLoading,
  hideContent,
  setHideContent,
}) {
  let history = useHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.buses?.requesInfo);
  const CityNames = useSelector((state) => state?.buses?.allCities);
  const [formData, setFormData] = useState({
    from: "",
    to: "",
    date: moment().format("YYYY-MM-DD"),
  });

  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const [cityData, setCityData] = useState([]);
  const [departureDate, setDepartureDate] = useState("Not Selected");
  const [returnDate, setReturnDate] = useState("Not Selected");
  const [infantCount, setInfantCount] = useState(data?.infantCount);
  const [childCount, setChildCount] = useState(data?.childCount);
  const [adultCount, setAdultCount] = useState(data?.adultCount);
  const [totalPassenger, setTotalPassenger] = useState(0);
  const [tripType, setTripType] = useState("One Way");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPassengerDropdown, setShowPassengerDropdown] = useState(false);
  const [requestInfor, setRequestInfor] = useState({
    from: "",
    to: "",
    departureDate: moment().format("YYYY-MM-DD"),
    returnDate: moment().format("YYYY-MM-DD"),
    totalPassenger: 0,
    tripType: "One Way",
    infantCount: 0,
    childCount: 0,
    adultCount: 0,
  });
  useEffect(() => {
    setRequestInfor({
      from: data?.from,
      to: data?.to,
      departureDate: data?.departureDate,
      returnDate: data?.returnDate,
      totalPassenger: data?.totalPassenger,
      tripType: data?.tripType,
      infantCount: data?.infantCount,
      childCount: data?.childCount,
      adultCount: data?.adultCount,
    });
    setDepartureDate(data?.departureDate);
    setReturnDate(data?.returnDate);
  }, [data]);

  useEffect(() => {
    setCityData(getCity());
  }, []);

  function handleChange(event, value) {
    const name = event.target.name || event.target.id;
    const newValue = value ? value.cityName : event.target.value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setRequestInfor((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (formData.from != "" && formData.to != "" && formData.date != "") {
      history.push(
        `/client/bus-listing/searchbus?from=${formData.from}&to=${formData.to}&date=${formData.date}`
      );
    }
  }

  function handleToButton(event) {
    setFormData({
      ...formData,
      ["to"]: event.target.id,
    });
    event.preventDefault();
  }

  function handleFromButton(event) {
    setFormData({
      ...formData,
      ["from"]: event.target.id,
    });
    event.preventDefault();
  }

  // function capitalize(word) {
  //   const lower = word.toLowerCase();
  //   return word.charAt(0).toUpperCase() + lower.slice(1);
  // }
  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  function getCity() {
    let city = JSON.parse(JSON.stringify(CitiesData));

    let cities = city.map((each) => each.city);

    return cities;
  }

  const CityNames1 = [
    { cityName: "Jeddah" },
    { cityName: "Makkah" },
    { cityName: "Riyadh" },
    { cityName: "Dubai" },
    { cityName: "Sharjah" },
    { cityName: "Madinah" },
    { cityName: "Dammam" },
    { cityName: "Taif" },
    { cityName: "Jizan" },
    { cityName: "Kuwait" },
    { cityName: "Manama" },
    { cityName: "Abu Dhabi" },
    { cityName: "Al Ain" },
    { cityName: "Ras Al Khaimah" },
    { cityName: "Buraydah" },
    { cityName: "Al Khobar" },
    { cityName: "Al Jubail" },
    { cityName: "Jazan" },
  ];

  const fromOptions = CityNames.filter(
    (city) => city.cityName !== requestInfor.to
  );

  const toOptions = CityNames.filter(
    (city) => city.cityName !== requestInfor.from
  );

  const handleSelectChange = (e) => {
    e.preventDefault();
    const newTripType = e.target.value;
    const updatedRequestInfor = {
      ...requestInfor,
      tripType: newTripType,
      departureDate: moment().format("DD MMM YY"),
      returnDate: moment().format("DD MMM YY"),
    };

    setRequestInfor(updatedRequestInfor);
    setTripType(newTripType);
    setDepartureDate(moment().format("DD MMM YY"));
    setReturnDate(moment().format("DD MMM YY"));
  };

  useEffect(() => {
    // Calculate the total number of passengers
    const totalPassenger =
      data?.infantCount + data?.childCount + data?.adultCount;

    // Update the requestInfor state
    setRequestInfor((prevState) => ({
      ...prevState,
      totalPassenger,
      infantCount: data?.infantCount || 0,
      childCount: data?.childCount || 0,
      adultCount: data?.adultCount || 1,
    }));
  }, [data]);

  const handleCloseDropdown = () => {
    setShowDropdown(false);
  };

  const searchBusSbmit = async () => {
    // ✅ Validation based on tripType
    if (
      ["One Way", "Round Trip", "Visa Package"].includes(requestInfor.tripType)
    ) {
      if (!requestInfor.from || !requestInfor.to) {
        Swal.fire({
          icon: "warning", // ⚠️ warning icon
          title: "Missing Information", // Title
          text: "Please enter both Departure City and Arrival City", // Message
          confirmButtonText: "OK", // Button text
        });
        return;
      }
    } else {
      if (!requestInfor.from) {
        Swal.fire({
          icon: "warning",
          title: "Missing Information",
          text: "Please enter Departure City",
          confirmButtonText: "OK",
        });
        return;
      }
    }

    // ✅ Dispatch dates
    if (requestInfor.tripType === "One Way") {
      dispatch(updateDepartureDate(departureDate));
    } else {
      dispatch(updateDates(departureDate, returnDate));
    }

    // ✅ Update request info
    await dispatch(UpdaterequestInfo(requestInfor));

    setIsLoading(true);

    // ✅ Hide content on small screens
    if (typeof window !== "undefined" && window.innerWidth <= 600) {
      setHideContent(true);
    }
  };

  console.log(requestInfor, "setHideContent");

  return (
    <>
      <div
        className="form searchform"
        onSubmit={(e) => handleSubmit(e)}
        style={{ display: "flex", flexWrap: "wrap" }}
      >
        <div className="form-each-box  tripSelection1 gap-[15px]">
          {/* <img src={building} alt="" className="form-logo" /> */}
          <div className="flex items-center tripSelection gap-[15px]">
            <div className="tripSelection">
              <Form.Select
                size="lg"
                value={requestInfor.tripType}
                onChange={(e) => handleSelectChange(e)}
              >
                <option>One Way</option>
                <option>Round Trip</option>
                <option>Umrah</option>
                <option>Madinah Ziyarah</option>
                <option>Umrah & Madinah Ziyarah</option>
                <option>Visa Package</option>
              </Form.Select>
            </div>
            <div className="SelectOuterNew">
              <Autocomplete
                className="locationSelect"
                disablePortal
                id="from"
                options={fromOptions}
                sx={{ width: "100%" }}
                getOptionLabel={(option) => option.cityName}
                value={
                  requestInfor.from
                    ? { cityName: capitalize(requestInfor.from) }
                    : null
                }
                onChange={(event, value) =>
                  handleChange({ target: { id: "from" } }, value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    cityName={languageSelectedEnglish ? "From" : language.from}
                    name="from"
                    onChange={(e) => handleChange(e)}
                    className="form-input"
                    required
                  />
                )}
              />
            </div>
          </div>
          {!["Umrah", "Madinah Ziyarah", "Umrah & Madinah Ziyarah"].includes(
            requestInfor.tripType
          ) && (
            <div className="form-each-box SelectOuterNew">
              {/* <img src={building} alt="" className="form-logo" /> */}
              <div className="SelectOuterNew">
                <Autocomplete
                  className="locationSelect"
                  disablePortal
                  id="to"
                  options={toOptions}
                  getOptionLabel={(option) => option.cityName}
                  sx={{ width: "100%" }}
                  value={
                    requestInfor.to
                      ? { cityName: capitalize(requestInfor.to) }
                      : null
                  }
                  onChange={(event, value) =>
                    handleChange({ target: { id: "to" } }, value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      cityName={languageSelectedEnglish ? "To" : language.to}
                      name="to"
                      onChange={(e) => handleChange(e)}
                      className="form-input"
                      required
                    />
                  )}
                />
              </div>
            </div>
          )}
        </div>
        <div className="dateSelectOuter tripsPage">
          <Grid
            item
            xs={12}
            className="form-each-box"
            width="100%"
            display="block"
            paddingLeft="0"
            paddingRight="0"
          >
            {/* <img src={building} alt="" className="form-logo" /> */}
            <Dropdown
              show={showDropdown}
              onToggle={(isOpen) => setShowDropdown(isOpen)}
              autoClose={false}
            >
              <Dropdown.Toggle
                variant="success"
                id="dropdown-passenger"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <Grid
                  container
                  xs={12}
                  justifyContent="space-between"
                  className="timing-wrapper"
                >
                  <Grid item xs={4} align="center">
                    <p className="tour-title">
                      {languageSelectedEnglish
                        ? "Departure Date"
                        : language.departureDate}
                    </p>
                    <p className="tour-date">{departureDate}</p>
                    <p className="tour-day">Tuesday</p>
                  </Grid>
                  {requestInfor.tripType == "Round Trip" && (
                    <Grid item alignSelf="center">
                      <div className="horizontal-rule" />
                    </Grid>
                  )}
                  {requestInfor.tripType == "Round Trip" && (
                    <Grid item xs={4} align="center">
                      <p className="tour-title">
                        {languageSelectedEnglish
                          ? " Return Date"
                          : language.returnDate}
                      </p>
                      <p className="tour-date">{returnDate}</p>
                      <p className="tour-day">Wednesday</p>
                    </Grid>
                  )}
                </Grid>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <CalendarComponent
                  departureDate={departureDate}
                  setDepartureDate={setDepartureDate}
                  returnDate={returnDate}
                  setReturnDate={setReturnDate}
                  tripType={tripType}
                  setTripType={setTripType}
                  onClose={handleCloseDropdown}
                  requestInfor={requestInfor}
                  setRequestInfor={setRequestInfor}
                  noOption={false}
                />
              </Dropdown.Menu>
            </Dropdown>
          </Grid>
        </div>

        <div className="passOuter passengerPut">
          <Grid item xs={12} className="passenger-wrap" marginTop="10px">
            <Dropdown
              show={showPassengerDropdown}
              autoClose={false}
              onToggle={(isOpen) => setShowPassengerDropdown(isOpen)}
            >
              <Dropdown.Toggle
                variant="success"
                id="dropdown-passenger"
                onClick={() => setShowPassengerDropdown(!showPassengerDropdown)}
              >
                <input
                  name="input"
                  type="text "
                  value={`${requestInfor?.infantCount} ${
                    languageSelectedEnglish ? "Infants" : language.infants
                  },${requestInfor?.childCount} ${
                    languageSelectedEnglish ? "Children" : language.children
                  },${requestInfor?.adultCount} ${
                    languageSelectedEnglish ? "Adults" : language.adults
                  }`}
                  placeholder={
                    languageSelectedEnglish
                      ? languageSelectedEnglish
                        ? "Not Selected"
                        : language.notSelected
                      : language.notSelected
                  }
                  readOnly
                  // value={formData.date}
                  // onChange={handleChange}
                  // min={moment().format("YYYY-MM-DD")}

                  className="form-input-text passengerPut"
                ></input>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Passengers
                  infantCount={infantCount}
                  setInfantCount={setInfantCount}
                  childCount={childCount}
                  setChildCount={setChildCount}
                  adultCount={adultCount}
                  setAdultCount={setAdultCount}
                  onClose={() => setShowPassengerDropdown(false)}
                />
              </Dropdown.Menu>
            </Dropdown>
          </Grid>
        </div>
        <button className="form-submit-button padBtn" onClick={searchBusSbmit}>
          {languageSelectedEnglish ? "Modify" : language.search}
        </button>
      </div>
    </>
  );
}
